import React from "react";
import PropTypes from "prop-types";
import "./styles.css";

function NotificationBadge({
  count = 0,
  maxDisplayCount = 99,
  className = "",
  ...otherProps // Spread other props here
}) {
  if (!count || count <= 0) return null;

  className = `notification-badge ${className}`.trim();

  return (
    <span className={className} {...otherProps}>
      {count > maxDisplayCount ? `${maxDisplayCount}+` : count}
    </span>
  );
}

// Define prop types
NotificationBadge.propTypes = {
  count: PropTypes.number,
  maxDisplayCount: PropTypes.number,
  className: PropTypes.string,
  // Allows all valid HTML span attributes as additional props
  otherProps: PropTypes.object,
};

// Set default props
NotificationBadge.defaultProps = {
  count: 0,
  maxDisplayCount: 99,
  className: "",
};

export default NotificationBadge;
